module.exports = __webpack_public_path__ + "img/sp-lp-plan@2x.d1572012.jpg";